// eslint-disable-next-line import/prefer-default-export
export const MATTERS_42_ACCESS_TOKEN = process.env.REACT_APP_MATTERS_42_ACCESS_TOKEN;
export const ZENDESK_KEY = process.env.REACT_APP_ZENDESK_KEY;
